<div class="userProfileAuditSection">
  <p-fieldset legend="Audit Trail" *ngIf="isDataLoaded">
    <div class="grid">
      <div class="col-6">
        <app-user-profile-audit-summary [summaryData]="userProfileAuditSummaryDetails"
          (onItemSelected)="showAuditItemDetails($event)">
        </app-user-profile-audit-summary>
      </div>
      <div class="col-6 auditTrialDetailsSection">
        <app-audit-item-details
          [auditTrialDetails]="auditAttributeDetailsOfTransaction">
        </app-audit-item-details>
      </div>
    </div>
  </p-fieldset>
</div>
